"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Seats.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Seats = function Seats(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 187.19 171.49"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "line-icon-seats"), _react2.default.createElement("g", {
    className: "seats",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "seat",
    d: "M180.1 3.79L168.4.39a9.77 9.77 0 0 0-12.1 6.7l-15.7 54.3c-1.5-.1-3-.2-4.5-.2a3.501 3.501 0 0 0-.2 7c.9 0 1.9.1 2.8.1l-19.7 67.9c0 .2-.1.3-.1.5a14.46 14.46 0 0 0-13.3-8.6l-52.8-3.5c.3-.8.5-1.6.8-2.4a3.58 3.58 0 0 0-2.2-4.5 3.46 3.46 0 0 0-4.5 2.2c-.5 1.4-1 2.8-1.4 4.3l-30.9-2h-.2c-8-.1-14.4 5.8-14.4 12.9v23.4c0 7.2 6.4 13 14.3 13h91c6.6 0 12.2-4.1 13.8-9.6a16.92 16.92 0 0 0 23.9-1.2 17.11 17.11 0 0 0 4.4-11.4v-.6a11.12 11.12 0 0 0 2-3.7l37.4-129.1a9.77 9.77 0 0 0-6.7-12.1zm-67.7 154.7c0 3.1-3.2 5.7-7 5.7h-91c-3.8 0-7-2.6-7-5.7v-23.3c0-3.1 3.2-5.7 6.9-5.7l90.9 6h.2c3.8 0 7 2.6 7 5.7v17.3zm27.7-6.4a9.92 9.92 0 1 1 .4-2.8 8.63 8.63 0 0 1-.4 2.8zm40.4-138l-36.3 125.4a17 17 0 0 0-17.6-6.7l35.9-123.9a3.24 3.24 0 0 1 4-2.2l11.8 3.3a3.23 3.23 0 0 1 2.2 4.1z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M111.3 69.79a2 2 0 0 0 .7-.1 118.93 118.93 0 0 1 11.8-1.5 3.51 3.51 0 1 0-.4-7 110.19 110.19 0 0 0-12.7 1.6 3.65 3.65 0 0 0-3 4 3.74 3.74 0 0 0 3.6 3zm-23.2 7.9a2.93 2.93 0 0 0 1.6-.4 73 73 0 0 1 10.8-4.6 3.542 3.542 0 0 0-2.3-6.7 82.37 82.37 0 0 0-11.8 5.1 3.47 3.47 0 0 0 1.7 6.6zm-34.7 35a3.62 3.62 0 0 0 4.7-1.6 80.67 80.67 0 0 1 5.9-10.3 3.54 3.54 0 0 0-5.9-3.9 87.62 87.62 0 0 0-6.3 11.1 3.56 3.56 0 0 0 1.6 4.7zm15.3-20a3.63 3.63 0 0 0 2.6-1.1 65.31 65.31 0 0 1 8.7-7.9 3.51 3.51 0 0 0-4.1-5.7l-.2.2a78.43 78.43 0 0 0-9.5 8.7 3.47 3.47 0 0 0 .2 4.9 3 3 0 0 0 2.3.9z",
    className: "dashed-lines",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = Seats;